export default "<ng-content></ng-content>\r\n"